import { BasePaymentPlatformStateModel, BasePaymentPlatformStateModelMock, DEFAULT_BASE_PAYMENT_PLATFORM_STATE_MODEL } from '../../models';
import { DEFAULT_LOADABLE_STATE, Loadable, LoadableMock, RecursivePartial } from '@aiwyn/shared';
import { merge } from 'ts-deepmerge';
import { SetupIntentsByBusinessEntity } from '@aiwyn/api';

export interface StripeStateModel extends BasePaymentPlatformStateModel {
  userId: Loadable<string>;
  setupIntentClientSecret: Loadable<string>;
  setupIntentClientSecretByBusinessEntity: Loadable<SetupIntentsByBusinessEntity>;
  selectedBusinessEntityId?: number;
  successfulSetupIntentIds?: Record<string, string>;
  // Email the buyer supplied outside the Stripe element (e.g. the sidebar recipient field), so a
  // direct-debit mandate can be satisfied without re-entering it in the element.
  providedBillingEmail?: string;
}

export const DEFAULT_STRIPE_STATE_MODEL: StripeStateModel = {
  ...DEFAULT_BASE_PAYMENT_PLATFORM_STATE_MODEL,
  userId: DEFAULT_LOADABLE_STATE,
  setupIntentClientSecret: DEFAULT_LOADABLE_STATE,
  setupIntentClientSecretByBusinessEntity: DEFAULT_LOADABLE_STATE,
};

export class StripeStateModelMock {
  protected _model: StripeStateModel = {
    ...new BasePaymentPlatformStateModelMock().model(),
    userId: new LoadableMock('1').model(),
    setupIntentClientSecret: new LoadableMock('seti_1').model(),
    setupIntentClientSecretByBusinessEntity: new LoadableMock({ default: 'seti_1', clientSecrets: [] }).model(),
    successfulSetupIntentIds: undefined,
  };

  constructor(overrides: RecursivePartial<StripeStateModel> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as StripeStateModel;
  }

  public model(): StripeStateModel {
    return this._model;
  }
}
